export default "__VITE_ASSET__CgWhCjMr__"